export default "/assets/7fc39f83bbe99b94.png"